exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mf_xtra{color:#9561e2;display:flex;justify-content:flex-end}", ""]);

// exports
